import translations from '../../components/location/ts/de';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('de', translations);
